const REFERRED_POINTER_DELIMITER = '_r_';
const REF_COMPONENT = 'wysiwyg.viewer.components.RefComponent';
export const SHARED_PARTS_PREFIX = 'sharedParts';
export const isNil = (value) => value == null;
export const isReferredId = (id) => id.includes(REFERRED_POINTER_DELIMITER);
export const getRefHostCompId = (compId) => isReferredId(compId)
    ? compId.substring(0, compId.lastIndexOf(REFERRED_POINTER_DELIMITER))
    : '';
export const isRefComponent = async (editorSDK, componentRef) => {
    const type = await editorSDK.components.getType('token', { componentRef });
    return type === REF_COMPONENT;
};
export const getRootRefHostCompId = (compId) => isReferredId(compId)
    ? compId.split(REFERRED_POINTER_DELIMITER)[0]
    : undefined;
export const getPrimaryConnectionItem = (connectionItems) => connectionItems.find((item) => item.isPrimary);
export const isRefHost = ({ componentType }) => componentType === REF_COMPONENT;
//# sourceMappingURL=structureUtils.js.map